// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1__b6d88c1e39f8d945b288","cls2":"buttonStyles-cls2__b9f58a4c6c3da93f0214 buttonStyles-cls1__b6d88c1e39f8d945b288"};